import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import CheckoutPage from '../pages/checkout/page';

const Layout = lazy(() => import('../pages/layout'));
const HomePage = lazy(() => import('../pages/home/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const PackagesPage = lazy(() => import('../pages/packages/page'));
const BookingPage = lazy(() => import('../pages/booking/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const AdminPage = lazy(() => import('../pages/admin/page'));
const BlogPage = lazy(() => import('../pages/blog/page'));
const ManualPage = lazy(() => import('../pages/manual/page'));
const EventsPage = lazy(() => import('../pages/events/page'));
const AlacartePage = lazy(() => import('../pages/alacarte/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/checkout',
    element: <CheckoutPage />,
  },
  {
    path: '/',
    element: <Layout />,
    children: [
      { index: true, element: <HomePage /> },
      { path: 'about', element: <AboutPage /> },
      { path: 'services', element: <ServicesPage /> },
      { path: 'packages', element: <PackagesPage /> },
      { path: 'booking', element: <BookingPage /> },
      { path: 'contact', element: <ContactPage /> },
      { path: 'blog', element: <BlogPage /> },
      { path: 'manual', element: <ManualPage /> },
      { path: 'events', element: <EventsPage /> },
      { path: 'alacarte', element: <AlacartePage /> },
      { path: 'admin', element: <AdminPage /> },
      { path: '*', element: <NotFound /> },
    ],
  },
];

export default routes;
